import { v4 as uuidv4 } from 'uuid';
import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  URL_BASE: 'https://apicreditosagilesdev.appsb.entornosb.com/',
  rqUID: uuidv4(),
  production: false,
  host: 'https://api.banistmodev.com',
  CLIENT_ID: 'cnb',
  sveChannelId: 'creditosagiles',
  AWS_BUCKET_NAME: 'awsuseast1-devintdigitalmedia',
  
  /** Externos. Pipeline reemplaza https://creditosagilesdev.appsb.entornosb.com/callback e creditosagiles. */
  authExternos: {
    configId: 'externos',
    authority: 'https://api.banistmodev.com/securityv2/OIDC',
    redirectUrl: 'https://creditosagilesdev.appsb.entornosb.com/callback',
    clientId: 'creditosagiles',
    responseType: 'code',
    scope: 'openid',
    host: 'https://local.mac.banistmodev.com',
    startChecksession: false,
    useRefreshToken: false,
    postLoginRoute: '/home',
    forbiddenRoute: '/forbidden',
    unauthorizedRoute: '/unauthorized',
    logConsoleWarningActive: true,
    logConsoleDebugActive: true,
    autoCleanStateAfterAuthentication: false,
    silentRenew: false,
    triggerAuthorizationResultEvent: true,
    maxIdTokenIatOffsetAllowedInSeconds: 5000,
    checkRedirectUrlWhenCheckingIfIsCallback: false,
    LogLevel: LogLevel.Debug,
  },
  /** Internos. Misma redirectUrl; pipeline reemplaza creditosagilesint. */
  authInternos: {
    configId: 'internos',
    authority: 'https://api.banistmodev.com/securityv2/OIDC',
    redirectUrl: 'https://creditosagilesdev.appsb.entornosb.com/callback',
    clientId: 'creditosagilesint',
    responseType: 'code',
    scope: 'openid',
    host: 'https://local.mac.banistmodev.com',
    startChecksession: false,
    useRefreshToken: false,
    postLoginRoute: '/home',
    forbiddenRoute: '/forbidden',
    unauthorizedRoute: '/unauthorized',
    logConsoleWarningActive: true,
    logConsoleDebugActive: true,
    autoCleanStateAfterAuthentication: false,
    silentRenew: false,
    triggerAuthorizationResultEvent: true,
    maxIdTokenIatOffsetAllowedInSeconds: 5000,
    checkRedirectUrlWhenCheckingIfIsCallback: false,
    LogLevel: LogLevel.Debug,
  },
};